import React from 'react'
import { LuSmartphoneNfc } from "react-icons/lu";
import { Bs0Circle, BsChatSquareText, BsChatSquareTextFill } from "react-icons/bs";
import { RiCustomerService2Line } from "react-icons/ri";

const SFBanner = () => {
  return (
    <>
    <div className="except2-container">
        <div className="except2">
        <div className="except2-inner">
            <h2>Communication made so simple</h2>
            <h2>with language helpers</h2>
            <div className="grid gap-6 sm:gap-2 sm:grid-cols-3 mt-16">
                <div className="except2-icons-container">
                    {/* <RiCustomerService2Line /> */}
                    <RiCustomerService2Line size={72} className="except2-icons" />
                    <h4>24/7 Customer Support</h4>
                </div>
                <div className="except2-icons-container">
                    {/* <RiCustomerService2Line /> */}
                    <BsChatSquareText size={70} className="except2-icons" />
                    <h4>50+ Language Translations</h4>
                </div>
                <div className="except2-icons-container">
                    {/* <RiCustomerService2Line /> */}
                    <LuSmartphoneNfc size={72} className="except2-icons" />
                    <h4>Remote/In-Person Assistance</h4>
                </div>
            </div>
        </div>
        </div>
    </div>
    </>
  )
}

export default SFBanner